import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-033f22be"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "login-content"
};
var _hoisted_2 = {
  class: "contest-area"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "slogon-box"
  }, null, -1);
});
var _hoisted_4 = {
  class: "login-box"
};
var _hoisted_5 = {
  class: "contest-bot"
};
var _hoisted_6 = {
  key: 0,
  class: "txt-center"
};
var _hoisted_7 = {
  key: 1,
  class: "txt-center"
};
import { ref, computed, onMounted } from 'vue';
import ContestLogin from './components/ContestLogin/index.vue';
import { useRouter, useRoute } from 'vue-router';
import { DaoService } from '@/services/dao.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var router = useRouter();
    var route = useRoute();
    var daoService = useService(DaoService);
    var loginConf = ref(null);
    var loginPageConfig = computed(function () {
      var _a;
      return ((_a = loginConf.value) === null || _a === void 0 ? void 0 : _a.loginPageConfig) || {};
    });
    var onGoIntro = function () {
      router.push({
        name: 'ContestLoginIntro',
        params: {
          suffix: route.params.suffix,
          _: route.params.suffix ? 's' : undefined,
          encryptId: route.params.encryptId
        }
      });
    };
    onMounted(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var encryptId, _a, _e_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              encryptId = route.params.encryptId;
              if (!encryptId) return [3 /*break*/, 4];
              _b.label = 1;
            case 1:
              _b.trys.push([1, 3,, 4]);
              _a = loginConf;
              return [4 /*yield*/, daoService.getUserLoginConf(encryptId)];
            case 2:
              _a.value = _b.sent();
              return [3 /*break*/, 4];
            case 3:
              _e_1 = _b.sent();
              _message.error('获取活动介绍配置失败');
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    });
    return function (_ctx, _cache) {
      var _a, _b, _c;
      return _openBlock(), _createElementBlock("div", {
        class: "common-login",
        style: _normalizeStyle({
          backgroundImage: ((_a = _unref(loginPageConfig)) === null || _a === void 0 ? void 0 : _a.banner) ? 'url(' + _unref(loginPageConfig).banner + ')' : 'none'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(ContestLogin, {
        loginConf: loginConf.value
      }, null, 8, ["loginConf"])])]), _createElementVNode("div", _hoisted_5, [_unref(loginPageConfig).desc ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(loginPageConfig).desc), 1)) : _createCommentVNode("", true), _unref(loginPageConfig).copyright ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(loginPageConfig).copyright), 1)) : _createCommentVNode("", true)])]), ((_c = (_b = loginConf.value) === null || _b === void 0 ? void 0 : _b.naviBarList) === null || _c === void 0 ? void 0 : _c.length) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "intro-guide",
        onClick: onGoIntro
      }, " 活动介绍 ")) : _createCommentVNode("", true)], 4);
    };
  }
});